<template>
    <div class="presentation-edit-nav-wrapper">
        <div
            class="presentation-edit-nav"
            role="tablist">
            <draggable
                group="navparts"
                :list="presentationIn.steps"
                handle=".step-drag-handle"
                @change="stepOrderChanged()"
                ghost-class="ghost">
                <design-2021-presentation-step-nav-component
                    v-for="step in presentationIn.steps"
                    :key="step.id"
                    :selected-slide-id="selectedSlideId"
                    @selected-slide="selectSlide"
                    @presentation-updated="updatePresentation"
                    @open-add-slide-modal="openAddSlideModal"
                    @open-edit-step-modal="openEditStepModal"
                    :step-in="step">
                </design-2021-presentation-step-nav-component>
            </draggable>
        </div>
        <div class="add-step">
            <b-button
                class="btn-add btn-add-step"
                @click="openAddStepModal"
                variant="primary">
                {{ $t('presentation.edit.add_step') }}
            </b-button>
        </div>
        <design-2021-presentation-add-step-modal
            :presentation-in="presentationIn"
            ref="add-step-modal"
            @presentation-updated="updatePresentation">
        </design-2021-presentation-add-step-modal>
        <design-2021-presentation-edit-step-modal
            :presentation-in="presentationIn"
            ref="edit-step-modal"
            @presentation-updated="updatePresentation">
        </design-2021-presentation-edit-step-modal>
        <design-2021-presentation-add-slide-modal
            :presentation-in="presentationIn"
            ref="add-slide-modal"
            @presentation-updated="updatePresentation">
        </design-2021-presentation-add-slide-modal>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
    name: 'design-2021-presentation-edit-nav-component',
    components: {
        draggable,
    },
    props: {
        presentationIn: {
            required: true,
            type: Object,
        },
        selectedSlideId: {
            required: false,
            type: Number,
            default: null,
        },
    },
    data() {
        return {};
    },
    methods: {
        stepOrderChanged() {
            let blocks = [];

            this.presentationIn.steps.forEach((step, i) => {
                blocks.push({
                    id: step.id,
                    order: i + 1,
                });
            });

            const data = {
                presentation_id: this.presentationIn.id,
                blocks: blocks,
            };

            this.axios.post(this.routes.presentationStepOrder(), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        updatePresentation(presentation) {
            this.$emit('presentation-updated', presentation);
        },
        openAddStepModal() {
            this.$refs['add-step-modal'].show();
        },
        openEditStepModal(step) {
            this.$refs['edit-step-modal'].show(step);
        },
        openAddSlideModal(step) {
            this.$refs['add-slide-modal'].show(step);
        },
        selectSlide(slideId) {
            this.$emit('selected-slide', slideId);
        },
    },
};
</script>

<style scoped lang="scss"></style>
